<template>
  <div class="shipments-charts">
    <AlgoliaCurrentFilters/>
    <ais-stats v-show="false">
      <div slot-scope="{ nbHits }">
        {{ totalResults = nbHits }}
      </div>
    </ais-stats>

    <EntityPerDayChart
      :mainDateFilter="mainDateFilter"
      :title="$t('shipments.shipments_per_day')"
      :entity="$t('reports.shipments')"
    />

    <ShipmentsMetricsPerDay :indexName="indexName" :mainDateFilter="mainDateFilter"/>

    <wrld-box :headerTitle="$tc('shipments.shipment')">
      <template v-slot:boxContent>
        <v-row>
          <v-col md="6" class="border-right">
            <PieChart
              :totalResults="totalResults"
              :label="$t('shipments.by_type')"
              attribute="status"
              color="#255aee"
            />
          </v-col>
          <!-- <v-col md="6">
            <PieChart
              :totalResults="totalResults"
              :label="$t('shipments.by_distance_in_km') + ' (1PL/2PL)'"
              attribute="distance"
              color="#7D02EB"
              :breakpoints="[100, 300, 500, 800, 1000]"
            />
            <CustomersCountryChart :totalResults="totalResults"/>
          </v-col> -->
        </v-row>
      </template>
    </wrld-box>

  </div>
</template>

<script>
import AlgoliaCurrentFilters from '@/components/general/AlgoliaCurrentFilters'
import ShipmentsMetricsPerDay from '@/components/reports/shipments/charts/ShipmentsMetricsPerDay'
import PieChart from '@/components/reports/PieChart'
import EntityPerDayChart from '@/components/reports/EntityPerDayChart'

export default {
  name: 'ShipmentsCharts',
  components: {
    AlgoliaCurrentFilters,
    ShipmentsMetricsPerDay,
    PieChart,
    EntityPerDayChart
  },
  props: {
    indexName: String
  },
  data () {
    return {
      totalResults: 0,
      mainDateFilter: 'pickupLocal.from'
    }
  }
}
</script>

<style lang="scss" scoped>
  .border-right {
    border-right: 1px lightgray solid;
  }
</style>
